/* eslint-disable camelcase */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Panel } from 'primereact/panel';
import { Messages } from 'primereact/messages';
import { Tooltip } from 'primereact/tooltip';

import Header from '@components/Header';

import { validarCertificado } from '@actions/certificado'

import './style.scss'

const DEFAULT_VALUES_STATE = {
  pais: "",
  fecha_creacion: "",
  proveedor: "",
  oficial_cumplimiento: "",
  evaluador: "",
  coordinador: "",
  fecha_expiracion: "",
  vigencia: "",
  isValido: "",
  folio: "",
  nivel_riesgo: "",
  ptr: ""
}
class ValidateTokenContract extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnLoadingValidateToken: false,
      token: "",
      tokenIsInvalid: false,
      tokenIsInvalidText: "",
      showAlert: false,
      ...DEFAULT_VALUES_STATE
    };
  }


  onValidateToken = async () => {
    const { t, validarCertificado } = this.props
    const { token } = this.state
    if (!token) return this.setState({tokenIsInvalid: true, tokenIsInvalidText: `${t('Token')} ${t('es requerido')}`})

    this.setState({btnLoadingValidateToken: true, showAlert: false, ...DEFAULT_VALUES_STATE})

    const response = await validarCertificado(token)

    if (!response?.status) {
      this.setState({
        pais: response.data?.pais_oc,
        fecha_creacion: response.data?.inicio_vigencia,
        proveedor: response.data?.razon_social_prov,
        oficial_cumplimiento: response.data?.nombre_oc,
        evaluador: response.data?.empresa_evaluadora,
        coordinador: response.data?.nombre_coordinador,
        fecha_expiracion: response.data?.fecha_expiracion,
        vigencia: response.data?.vigencia,
        isValido: response.data?.dias_vigencia > 0,
        folio: response.data?.folio,
        nivel_riesgo: response.data?.nivel_riesgo_oc,
        ptr: response.data?.ptr
      })
      
      await this.setState({showAlert: true})
      this.msIsValid.clear()
       if (response.data.dias_vigencia  > 0 ) this.msIsValid.show({severity: 'success', summary: t('El certificado es valido')});
       else this.msIsValid.show({severity: 'error', summary: t('El certificado ha expirado. Favor de notificar al proveedor'), closable: false, sticky: true});
    } else if(response.status === 404) {
      this.setState({tokenIsInvalid: true, tokenIsInvalidText: `${t(response.data.acknowledgementDescription)}`})
    }

    return this.setState({btnLoadingValidateToken: false})
  }

  onChange = ({target}) => {
    if (target.name === 'token') {
      this.setState({tokenIsInvalid: false})
      target.value = target.value.replaceAll('\n', '').replaceAll(' ', '')
    }
    this.setState({[target.name]: target.value})
  }

  getFolio = () => {
    const { token } = this.state
    const splitToken = token.split("|")
    return splitToken[0]
  }

  restartingValidation = () => {
    this.setState({
      token: "",
      showAlert: false,
      ...DEFAULT_VALUES_STATE
    })
  }


  render() {
    const { t, history } = this.props;
    const {
      btnLoadingValidateToken,
      token,
      showAlert,

      pais,
      fecha_creacion,
      proveedor,
      oficial_cumplimiento,
      evaluador,
      coordinador,
      fecha_expiracion,
      vigencia,
      ptr,
      nivel_riesgo,
      folio,
      isValido,
      tokenIsInvalid,
      tokenIsInvalidText
    } = this.state;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
      </>
    );

    return (
      <div className="p-grid validate-token">
        <div className="p-col-12">
          <Header title={t('Validar sello digital')} rightComponent={rightHeader} />
            <div className='p-grid card p-pt-0 p-mt-0'>

            { showAlert && (
            <div className='p-col-12 p-pt-0'>
              <Messages ref={(el) => this.msIsValid = el} />
            </div>
            )}

            <div className='p-col-12 p-text-right p-p-0 p-mt-2'>
              <Button
                icon="pi pi-refresh"
                className="p-button-raised p-button-text p-button-plain"
                onClick={() => this.restartingValidation()}
              />
            </div>

              <div className={`p-col-12 p-grid p-fluid p-mr-2 ${proveedor ? "p-lg-5" : "p-lg-12"}`}>
                <h4 className='p-col-12 p-mb-0'>{t('Codificación')}</h4>
                <div className='p-col-12'>
                  <label className='p-text-bold p-mb-2'>
                    {t('Inserta la cadena del cetificado que deseas validar.')}
                    <Tooltip target=".custom-tooltip-btn"  autoHide={false}>
                      <img alt="logo" src="/assets/img/help-validate-token-contract.PNG" data-pr-tooltip="Token_contract" height="297px" width="280px"/>
                    </Tooltip>

                    <Button className="custom-tooltip-btn p-button-text p-p-0" type="button" icon="pi pi-info-circle" />
                  </label>
                  <InputTextarea
                    rows={15}
                    name="token"
                    value={token}
                    onChange={this.onChange}
                    placeholder="PDD04052022-006|VlVWU1JVMUVVWGRPVkVsM1RXcEpkRTFFUVRKSmVUQnFUV3BCZVUxcE1IZE9VekIzVGtaUmVVMUViekJOVkc5NVRVTk5kRWw2U1ROT1EwMTBTWHBWYWt4VFRUQkplVEJxVFZSQk5VbDVNR3BOYWtGNVRXa3dkMDVUTUhkT1JsRjVUVVJ2TUUxVWIzbE5RVDA5|2"
                    className={classNames('placeholder-custom p-mt-2', {
                      'p-invalid': (proveedor && !isValido) || tokenIsInvalid,
                      'border-success': proveedor && isValido
                    })}
                  />
                  { tokenIsInvalid && (
                    <small className="p-error">{tokenIsInvalidText}</small>
                  )}
                </div>
                { proveedor && (
                  <div className='p-col-12'>
                    { isValido ? (
                        <h5 className='p-col-12 p-mb-0 p-text-center p-success'>
                          <i className='pi pi-thumbs-up p-mr-2'> </i>
                          {t('Firma verificada')}
                        </h5>
                    ) : (
                      <h5 className='p-col-12 p-mb-0 p-text-center p-error'>
                        <i className='pi pi-times-circle p-mr-2'> </i>
                        {t('Cadena inválida')}
                      </h5>
                    )

                    }

                  </div>
                )}
                <div className="p-col-12 p-text-center">
                  <Button
                    type="button"
                    icon="pi pi-key"
                    className='p-button-success'
                    label={t('Validar sello digital')}
                    loading={btnLoadingValidateToken}
                    onClick={() => this.onValidateToken()}
                    style={{width: proveedor ? "100%" : "70%"}}
                  />
                </div>
              </div>

              { proveedor && (
                <div className="p-col-12 p-lg-7 p-grid p-fluid">
                  <h4 className='p-col-12 p-mb-0'>{t('Decodificación')}</h4>

                  <Panel header={t('Estatus')} className='p-mb-3 p-col-12' toggleable>
                    <div className='p-grid'>
                      <div className="p-col-6">
                        <label className='p-text-bold'>{t('Folio')}</label>
                        <InputText
                          name="folio"
                          value={this.getFolio()}
                          disabled
                        />
                      </div>
                      <div className="p-col-6">
                        <label className='p-text-bold'>{t('Nivel de riesgo')}</label>
                        <div className='p-inputgroup'>
                          <span className="p-inputgroup-addon">
                            <i className="pi pi-chart-line" />
                          </span>
                          <InputText
                            name="nivel_riesgo"
                            value={nivel_riesgo}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="p-col-12">
                        <label className='p-text-bold'>{t('Tipo de proceso')}</label>
                        <InputText
                          name="ptr"
                          value={ptr}
                          disabled
                        />
                      </div>
                    </div>
                  </Panel>

                  <Panel header={t('Información del contrato')} className='p-mb-3 p-col-12'>
                    <div className='p-grid'>
                      <div className="p-col-6">
                        <label className='p-text-bold'>{t('País')}</label>
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-globe" />
                            </span>
                            <InputText
                              name="pais"
                              value={pais}
                              disabled
                            />
                        </div>
                      </div>
                      <div className="p-col-6">
                        <label className='p-text-bold'>{t('Fecha de Creación')}</label>
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-bookmark" />
                            </span>
                            <InputText
                              name="fecha_creacion"
                              value={fecha_creacion}
                              disabled
                            />
                        </div>
                      </div>
                      <div className="p-col-12">
                        <label className='p-text-bold'>{t('Proveedor')}</label>
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-briefcase" />
                            </span>
                            <InputText
                              name="proveedor"
                              value={proveedor}
                              disabled
                            />
                        </div>
                      </div>
                      <div className="p-col-12">
                        <label className='p-text-bold'>{t('Oficial de cumplimiento')}</label>
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-id-card" />
                            </span>
                            <InputText
                              name="oficial_cumplimiento"
                              value={oficial_cumplimiento}
                              disabled
                            />
                        </div>
                      </div>
                      <div className="p-col-12">
                        <label className='p-text-bold'>{t('Coordinador')}</label>
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-users" />
                            </span>
                            <InputText
                              name="coordinador"
                              value={coordinador}
                              disabled
                            />
                        </div>
                      </div>
                      <div className="p-col-12">
                        <label className='p-text-bold'>{t('Evaluador')}</label>
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-users" />
                            </span>
                            <InputText
                              name="evaluador"
                              value={evaluador}
                              disabled
                            />
                        </div>
                      </div>
                      <div className="p-col-6">
                        <label className='p-text-bold'>{t('Fecha de Expiración')}</label>
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-calendar-times" />
                            </span>
                            <InputText
                              name="fecha_expiracion"
                              value={fecha_expiracion}
                              disabled
                            />
                        </div>
                      </div>
                      <div className="p-col-6">
                        <label className='p-text-bold'>{t('Vigencia')}</label>
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">
                                <i className="pi pi-bell" />
                            </span>
                            <InputText
                              name="vigencia"
                              value={`${vigencia}`}
                              disabled
                            />
                        </div>
                      </div>
                    </div>
                  </Panel>

                  <Panel header={t('Información adicional')} className='p-mb-3 p-col-12' toggleable collapsed>
                    <div className='p-grid'>
                      <div className="p-col-12">
                        <p>Pronto tendemós mas información que mostrar.</p>
                      </div>
                    </div>
                  </Panel>

                </div>
              )}

            </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {
  validarCertificado
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
  )(ValidateTokenContract);
